/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { DISABLED_CLASSNAME } from '@constants';

import Form from '@organisms/Form';

import MediaSelect from '../MediaSelect';

const MediaField = ({ name, label, rules, style, ...props }) => (
  <Form.Item name={name} label={label} rules={rules} style={style} className={props.disabled && DISABLED_CLASSNAME}>
    <MediaSelect {...props} />
  </Form.Item>
);

export default MediaField;
